import { createHttpClient } from "./httpClientFactory";
import { staffTokenStore } from "./tokenStore";

export const staffApi = createHttpClient({
  refreshPath: "/auth/staff/refresh",
  tokenStore: staffTokenStore,
});
